import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

import { Glyph } from '../../iconography/Glyph';
import sx from '../../internal/styles/sx';
import { SystemModalCloseIconProps } from './types';

const CloseButtonContainer = styled('button')(
  {
    display: 'flex',
    justifyContent: 'center',
    height: '20px',
    width: '20px',
    position: 'absolute',
    top: '50%',
    left: '24px',
    transform: 'translate(0%,-50%)',
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    borderRadius: '100%',
  },
  sx
);

const SystemModalCloseIcon = forwardRef<
  HTMLButtonElement,
  SystemModalCloseIconProps
>(({ 'aria-label': ariaLabel, onClose, children, sx }, ref) => {
  return (
    <CloseButtonContainer
      onClick={onClose}
      ref={ref}
      aria-label={ariaLabel}
      sx={sx}
    >
      {children ?? <Glyph category="UIActions" name="Clear" size="small" />}
    </CloseButtonContainer>
  );
});

export default SystemModalCloseIcon;
